import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ReportsService } from 'src/app/services/reports.service';
import { first } from 'rxjs';
import saveAs from 'file-saver';
import { VendorMiArea } from 'src/app/models/department-reports.model';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { shareReplay } from 'rxjs/operators';
import { BaseService } from 'src/app/services/common/base.service';
import { FarmerLandDetailService } from 'src/app/services/farmer-land-detail.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import { UIChart } from 'primeng/chart';
import { InnerPageLayoutComponent } from 'src/app/components/layouts/inner-page-layout/inner-page-layout.component';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-consolidated-report',
  templateUrl: './consolidated-report.component.html',
  styleUrls: ['./consolidated-report.component.scss'],
})
export class ConsolidatedReportComponent implements OnInit {
  @ViewChild('pieChart') pieChartRef: UIChart;
  // @ViewChild("lineChart") lineChartRef: UIChart;
  consolidateData: any = [];
  totalApp: any;
  totalArea: any;
  verifiedApp: any;
  verifiedAppArea: any;
  pendingApp: any;
  incompleteApp: any;
  incompleteAppArea: any;
  rejectApp: any;
  totalEstimatedApp: any;
  totalEstimatedArea: any;
  verifiedEstimateApp: any;
  verifiedEstimateArea: any;
  pendingEstimateApp: any;
  verifiedEstApproved: any;
  verifiedEstApprovedArea: any;
  pendingEstApproved: any;
  rejectedEstVerified: any;
  challanGenerated: any;
  challanDeposited: any;
  BOQUploaded: any;
  BOQMIArea: any;
  BOQPending: any;
  PVCompleted: any;
  PV_MI_Area: any;
  PV_Pending_with_JE: any;
  PV_Pending_with_XEN: any;
  pending_Subsidy_Calculation: any;
  applicationswithDMIforSubsidy_Approval: any;
  applications_Approved_at_Administartion: any;
  subsisdy_Approved_MI_Area: any;
  assistanceAmount: any;
  pending_Application_For_Payment_By_CAO: any;
  payment_Done_Application_By_CAO: any;
  payment_done_MI_Area: any;

  grandTotalApp: any;
  grandTotalArea: any;
  grandVerifiedApp: any;
  grandVerifiedAppArea: any;
  grandPendingApp: any;
  grandIncompleteApp: any;
  grandIncompleteAppArea: any;
  grandRejectApp: any;
  grandTotalEstimatedApp: any;
  grandTotalEstimatedArea: any;
  grandVerifiedEstimateApp: any;
  grandVerifiedEstimateArea: any;
  grandPendingEstimateApp: any;
  grandVerifiedEstApproved: any;
  grandVerifiedEstApprovedArea: any;
  grandPendingEstApproved: any;
  grandRejectedEstVerified: any;
  grandChallanGenerated: any;
  grandChallanDeposited: any;
  grandBOQUploaded: any;
  grandBOQMIArea: any;
  grandBOQPending: any;
  grandPVCompleted: any;
  grandPV_MI_Area: any;
  grandPV_Pending_with_JE: any;
  grandPV_Pending_with_XEN: any;
  grandPending_Subsidy_Calculation: any;
  grandApplicationswithDMIforSubsidy_Approval: any;
  grandApplications_Approved_at_Administartion: any;
  grandSubsisdy_Approved_MI_Area: any;
  grandAssistanceAmount: any;
  grandPending_Application_For_Payment_By_CAO: any;
  grandPayment_Done_Application_By_CAO: any;
  grandPayment_done_MI_Area: any;

  arrayIndex: number;
  tempConsolidateData: any[];
  appVerificationItems: MenuItem[];
  appVerificationModel: VendorMiArea[];
  filteredDataForExport: any = [];
  cols: (
    | { field: string; header: string; customExportHeader: string }
    | { field: string; header: string; customExportHeader?: undefined }
  )[];
  exportColumns: { title: string; dataKey: string }[];
  public filteredData: any = [];
  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;

  public userID: any;
  public displayMaximizable: boolean;
  public displayMaximizable_totalApp: boolean;
  public displayMaximizable_pendingApp: boolean;
  public drilldownDetails: any;
  public pendingType: any;
  public displayMaximizable_rejectedApp: any;
  public vendorName: any;
  public name: any;
  public selectedYear: any;
  public financialYears: any[] = [];
  public routePath: any;
  public subjectSub: any;
  public subscriptions: any = [];
  public loading: boolean = false;
  public isChartLoading: boolean = false;

  public displayPendingDetailUser: boolean = false;
  public displayPendingDetailUserWise: boolean = false;
  public summaryData: any = [];

  public data: any;
  public data1: any;
  public options: any;
  public options1: any;
  public count: number = 0;
  public isFinYearChanged: boolean = false;
  public cropTypeList: any[];
  public cropBasedNames: any;
  public selectedCrop: any;
  public selectedProgram: any;
  public program: any;
  public caste: any;
  public selectedCaste: any;
  public appType: any;
  public selectedAppType: any;
  public districtsArray: any = [];
  public distWiseTotalApp: any = [];

  public finYearData: any = [
    {
      year: 'All',
      code: 0,
    },
    {
      year: '2022-23',
      code: 1,
    },
    {
      year: '2023-24',
      code: 2,
    },
  ];
  public selectedFinYear: any = { year: 'All', code: 0 };

  // for MI
  public pieChartData: any = [];
  public lineGraphData: any = [];
  public card1CountData: any = [];
  public districtWiseData: any = [];

  // for Pond
  public pondCard1CountData: any = [];

  // for solar
  public solarCard1CountData: any = [];

  // for waterCourse
  public waterCourseCard1CountData: any = [];

  
  public isAdminLogin: boolean = false;
  public isMIChecked: boolean = false;
  public isPondChecked: boolean = false;
  public isSolarChecked: boolean = false;
  public isWaterCourseChecked: boolean = false;

  public userIdUpperCase: any;
  @ViewChild('divClick') divClick: ElementRef;

  constructor(
    private reportsService: ReportsService,
    private messageService: MessageService,
    private dashboard: DashboardService,
    private router: Router,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private service: BaseService,
    private flService: FarmerLandDetailService,
    private vendorService: VendorDashboardService,
    public appMain: InnerPageLayoutComponent,
    private cryptoJsService: CryptoJsService
  ) {}

  ngOnInit(): void {
    // setTimeout(() => {
    //   this.divClick.nativeElement.click();
    //   }, 200);
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userIdUpperCase = JSON.parse(payload)?.sub

    this.userID = (JSON.parse(payload)?.sub).toLowerCase();

    this.isMIChecked = true;
    this.isPondChecked = false;
    this.isSolarChecked = false;
    this.isWaterCourseChecked = false;

    // if (sessionStorage.getItem('financialYear')) {
    //   this.service.changeFinancialYear(sessionStorage.getItem('financialYear'));
    // }
    if(this.userID == 'admin'){
      this.isAdminLogin = true;
      // this.isAdminLogin = false;
    }else{
      this.isAdminLogin = false;
    }
    

    this.appVerificationItems = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.appVerificationModel, 'MI_Consolidate_report');
        },
      },
      {
        label: 'Download Pdf',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.downloadSheetAsPdf(
            this.appVerificationModel,
            'MI_Consolidate_report'
          );
        },
      },
    ];
    if(this.userID =='dd-ew'){
      this.isMIChecked = false;
      this.isPondChecked = true;
    }

    if(this.userID == 'dd-ew'){
      this.onComponentBoxClick('Pond')
    }else{
      this.onComponentBoxClick('MI')
      // this.onFinYearChange();
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }


  onComponentBoxClick(val){
    if(val == 'MI'){
      this.isMIChecked = true;
      this.isPondChecked = false;
      this.isSolarChecked = false;
      this.isWaterCourseChecked = false;
    }else if(val == 'Pond'){
      this.isMIChecked = false;
      this.isPondChecked = true;
      this.isSolarChecked = false;
      this.isWaterCourseChecked = false;
    }else if(val == 'Solar'){
      this.isMIChecked = false;
      this.isPondChecked = false;
      this.isSolarChecked = true;
      this.isWaterCourseChecked = false;
    }else if(val == 'WaterCourse'){
      this.isMIChecked = false;
      this.isPondChecked = false;
      this.isSolarChecked = false;
      this.isWaterCourseChecked = true;
    }

    this.onFinYearChange();
  }

  refreshData(){
    let val = this.selectedFinYear.year;
    if (this.selectedFinYear.year == 'All') {
      val = '';
    }

    if(this.userID == 'admin' || this.userID == 'cao'){
      if(this.isMIChecked){
        // this.checkMIDataInSessionStorage(val);
        this.getMICard1CountData(val);
        // this.getDistrictWiseData(val);
        // this.getLineGraphData(val);
      }else if(this.isPondChecked){
        // this.checkPondDataInSessionStorage(val);
        this.getPondCard1CountData(val);
      }
      // else if(this.isSolarChecked){
      //   this.getSolarCard1CountData(val);
      // }else if(this.isWaterCourseChecked){
      //   this.getWaterCourseCard1CountData(val);
      // }
    }else if(this.userID == 'dmicada'){
      // this.checkMIDataInSessionStorage(val);
      this.getMICard1CountData(val);
      // this.getDistrictWiseData(val);
      // this.getLineGraphData(val);
    }else if(this.userID == 'dd-ew'){
      // this.checkPondDataInSessionStorage(val);
      this.getPondCard1CountData(val);
    }
  }

  onFinYearChange() {
    // console.log(this.selectedFinYear);
    let val = this.selectedFinYear.year;
    if (this.selectedFinYear.year == 'All') {
      val = '';
    }

    if(this.userID == 'admin' || this.userID == 'cao'){
      if(this.isMIChecked){
        // this.getMICard1CountData(val);
        this.checkMIDataInSessionStorage(val);
        // this.getDistrictWiseData(val);
        // this.getLineGraphData(val);
      }else if(this.isPondChecked){
        // this.getPondCard1CountData(val);
        this.checkPondDataInSessionStorage(val);
        // this.getDistrictWiseData(val);
        // this.getLineGraphData(val);
      }else if(this.isSolarChecked){
        this.getSolarCard1CountData(val);
        // this.getDistrictWiseData(val);
        // this.getLineGraphData(val);
      }else if(this.isWaterCourseChecked){
        this.getWaterCourseCard1CountData(val);
        // this.getDistrictWiseData(val);
        // this.getLineGraphData(val);
      }
    }else if(this.userID == 'dmicada'){
      // this.getMICard1CountData(val);
      this.checkMIDataInSessionStorage(val);
      // this.getDistrictWiseData(val);
      // this.getLineGraphData(val);
    }else if(this.userID == 'dd-ew'){
      // this.getPondCard1CountData(val);
      this.checkPondDataInSessionStorage(val);
      // this.getDistrictWiseData(val);
      // this.getLineGraphData(val);
    }
  }

  onClickMIBox(name, actionId){
    const finYear = this.selectedFinYear.year;

    if(this.userID == 'admin'){
      this.router.navigate(['admin', 'report', 'consolidated-report', actionId, finYear]);
    }
    else if(this.userID == 'cao'){
      this.router.navigate(['cao', 'report', 'consolidated-report', actionId, finYear]);
    }
    else{
      this.router.navigate(['department', 'report', 'consolidated-report', actionId, finYear]);
    }
  }

  onClickPondBox(name, actionId){
    const finYear = this.selectedFinYear.year;

    if(this.userID == 'admin'){
      this.router.navigate(['admin', 'report', 'pond-report', actionId, finYear]);

    }
    else if(this.userID == 'cao'){
      this.router.navigate(['cao', 'report', 'pond-report', actionId, finYear]);
    }
    else{
      this.router.navigate(['ew-department', 'report', 'pond-report', actionId, finYear]);
    }
  }

  onClickSolarBox(name, count){

  }

  onClickWaterCourseBox(name, count){

  }

  checkPondDataInSessionStorage(finYear){
    if (finYear == '' && window.sessionStorage.getItem('PondDashboardDataAll')) {
      let val = JSON.parse(window.sessionStorage.getItem('PondDashboardDataAll'));
      this.pondCard1CountData = val[0];
      this.loadPieChartData();
    }
    else if (finYear == '2022-23' && window.sessionStorage.getItem('PondDashboardData2223')) {
      let val = JSON.parse(window.sessionStorage.getItem('PondDashboardData2223'));
      this.pondCard1CountData = val[0];
      this.loadPieChartData();
    }
    else if (finYear == '2023-24' && window.sessionStorage.getItem('PondDashboardData2324')) {
      let val = JSON.parse(window.sessionStorage.getItem('PondDashboardData2324'));
      this.pondCard1CountData = val[0];
      this.loadPieChartData();
    }
    else{
      this.getPondCard1CountData(finYear);
    }
  }

  checkMIDataInSessionStorage(finYear){
    if (finYear == '' && window.sessionStorage.getItem('MIDashboardDataAll')) {
      let val = JSON.parse(window.sessionStorage.getItem('MIDashboardDataAll'));
      this.card1CountData = val[0];
      this.loadPieChartData();
    }
    else if (finYear == '2022-23' && window.sessionStorage.getItem('MIDashboardData2223')) {
      let val = JSON.parse(window.sessionStorage.getItem('MIDashboardData2223'));
      this.card1CountData = val[0];
      this.loadPieChartData();
    }
    else if (finYear == '2023-24' && window.sessionStorage.getItem('MIDashboardData2324')) {
      let val = JSON.parse(window.sessionStorage.getItem('MIDashboardData2324'));
      this.card1CountData = val[0];
      this.loadPieChartData();
    }
    else{
      this.getMICard1CountData(finYear);
    }
  }

  getMICard1CountData(finYear) {
    this.loader.start();
    let sub = this.reportsService
      .getMIAggregateTabsDataNew(finYear)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data?.length > 0) {
            this.card1CountData = data[0];
            this.loadPieChartData();

            //save data in session storage
            if (finYear == '') {
              window.sessionStorage.setItem('MIDashboardDataAll', JSON.stringify(data));
            }
            else if (finYear == '2022-23') {
              window.sessionStorage.setItem('MIDashboardData2223', JSON.stringify(data));
            }
            else if (finYear == '2023-24') {
              window.sessionStorage.setItem('MIDashboardData2324', JSON.stringify(data));
            }

          } else {
            this.card1CountData = [];
            this.loadPieChartData();
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Available',
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.card1CountData = [];
          this.loadPieChartData();
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });
  }
  getLineGraphData(finYear) {
    let sub = this.reportsService
      .getSubsidyDisbursedAgg(finYear)
      .pipe(first())
      .subscribe({
        next: (data) => {
          if (data?.length > 0) {
            this.lineGraphData = data;
            this.loadLineGraphData();
          } else {
            this.lineGraphData = [];
            this.loadBarGraphData();
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Available',
            });
          }
        },
        error: (err) => {
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });
  }
  getDistrictWiseData(finYear) {
    let sub = this.reportsService
      .aggDataDistrictWiseForGraph(finYear)
      .pipe(first())
      .subscribe({
        next: (data) => {
          if (data?.length > 0) {
            this.districtWiseData = data;
            this.loadBarGraphData();
            // this.loadPieChartData();
            // this.loadPieChartData();
          } else {
            this.districtWiseData = [];
            this.loadBarGraphData();
            // this.loadPieChartData();
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Available',
            });
          }
        },
        error: (err) => {
          this.districtWiseData = [];
          this.loadBarGraphData();
          // this.loadPieChartData();
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });
  }

  getPondCard1CountData(finYear) {
    this.loader.start();
    let sub = this.reportsService
      .getPondAggregateTabsDataNew(finYear)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data?.length > 0) {
            this.pondCard1CountData = data[0];
            this.loadPieChartData();

            //save data in session storage
            if (finYear == '') {
              window.sessionStorage.setItem('PondDashboardDataAll', JSON.stringify(data));
            }
            else if (finYear == '2022-23') {
              window.sessionStorage.setItem('PondDashboardData2223', JSON.stringify(data));
            }
            else if (finYear == '2023-24') {
              window.sessionStorage.setItem('PondDashboardData2324', JSON.stringify(data));
            }

          } else {
            this.pondCard1CountData = [];
            this.loadPieChartData();
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Available',
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.pondCard1CountData = [];
          this.loadPieChartData();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  getSolarCard1CountData(finYear) {
    // let sub = this.reportsService
    //   .getConsolidatedAggReportNew2(finYear)
    //   .pipe(first())
    //   .subscribe({
    //     next: (data) => {
    //       if (data?.length > 0) {
    //         this.pondCard1CountData = data[0];
    //       } else {
    //         this.pondCard1CountData = [];
    //         this.messageService.add({
    //           severity: 'info',
    //           summary: 'Info Message',
    //           detail: 'Data Not Available',
    //         });
    //       }
    //     },
    //     error: (err) => {
    //       this.pondCard1CountData = [];
    //       this.messageService.add({
    //         severity: 'error',
    //         summary: 'Error Message',
    //         detail: err,
    //       });
    //     },
    //   });

    this.solarCard1CountData = {
      // totalApp: 50000,
      // TotalApprovedApp: 45000,
      // challanGenerated: 30450,
      // installDone: 21500,
      totalApp: 0,
      TotalApprovedApp: 0,
      challanGenerated: 0,
      installDone: 0,
    }
    this.loadPieChartData();
  }

  getWaterCourseCard1CountData(finYear) {
    // let sub = this.reportsService
    //   .getConsolidatedAggReportNew2(finYear)
    //   .pipe(first())
    //   .subscribe({
    //     next: (data) => {
    //       if (data?.length > 0) {
    //         this.pondCard1CountData = data[0];
    //       } else {
    //         this.pondCard1CountData = [];
    //         this.messageService.add({
    //           severity: 'info',
    //           summary: 'Info Message',
    //           detail: 'Data Not Available',
    //         });
    //       }
    //     },
    //     error: (err) => {
    //       this.pondCard1CountData = [];
    //       this.messageService.add({
    //         severity: 'error',
    //         summary: 'Error Message',
    //         detail: err,
    //       });
    //     },
    //   });

    this.waterCourseCard1CountData = {
      // totalApp: 45300,
      // TotalApprovedApp: 34200,
      // workDone: 20500,
      totalApp: 0,
      TotalApprovedApp: 0,
      workDone: 0
    }
    this.loadPieChartData();
  }

  // graph1
  loadBarGraphData() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

        
    const districtArray = this.districtWiseData.map((item) => item['District']);
    const totalApp = this.districtWiseData.map((item) => item['totalApp']);
    const verifiedApp = this.districtWiseData.map(
      (item) => item['VerifiedApp']
    );
    const incomplete = this.districtWiseData.map(
      (item) => item['IncompleteApp']
    );
    // const rejected = this.districtWiseData.map(item => item["rejectApp"]);

    // console.log(districtArray);
    this.data1 = {
      labels: districtArray,
      datasets: [
        {
          label: 'Total App',
          backgroundColor: documentStyle.getPropertyValue('--blue-500'),
          borderColor: documentStyle.getPropertyValue('--blue-500'),
          data: totalApp,
        },
        {
          label: 'Verified App',
          backgroundColor: documentStyle.getPropertyValue('--green-500'),
          borderColor: documentStyle.getPropertyValue('--green-500'),
          data: verifiedApp,
        },
        {
          label: 'Incomplete',
          backgroundColor: documentStyle.getPropertyValue('--pink-500'),
          borderColor: documentStyle.getPropertyValue('--pink-500'),
          data: incomplete,
        },
      ],
    };

    // this.options1 = {
    //   scales: {
    //     yAxes: [{
    //       ticks: {
    //         stepSize: 2, // Set the step size for the y-axis ticks
    //         beginAtZero: true // Start the y-axis at zero
    //       }
    //     }]
    //   }
    // };

    this.options1 = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        legend: {
          labels: {
            color: textColor,
          },
        },
      },
      scales: {
        x: {
          ticks: {
            color: textColorSecondary,
            font: {
              weight: 800,
            },
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false,
          },
        },
        y: {
          type: 'logarithmic', // Use logarithmic scale
          ticks: {
            min: 0, // Set the minimum value
            // stepSize: 2,
            // callback: function(value, index, values) {
            //   if (value === 1) return 0; // Set the first label to 0
            //   const labels = ['500', '1000', '5000', '10000', '50000', '100000']; // Custom labels
            //   return labels[index]; // Return custom labels
            // }
            font: {
              weight: 200,
            },
          },
          // ticks: {
          //   font: {
          //     weight: 700,
          //   },
          //   stepSize: 100,
          //   color: textColorSecondary,
          // },
          grid: {
            display: false,
            // color: this.surfaceBorder,
            // drawBorder: false,
          },
        },
      },
      // scales: {
      //   yAxes: [{
      //     ticks: {
      //       stepSize: 2,
      //       beginAtZero: true
      //     }
      //   }]
      // }
      // scales: {
      //   y: [{
      //     scaleLabel: {
      //       display: true,
      //       labelString: '100' // Change this to your desired y-axis label
      //     }
      //   }]
      // }
    };
  }

  // graph2
  loadPieChartData() {
    // let labels = [];
    // let areaData = [];
    // let backgroundColors = [];
    // for (let index = 0; index < this.districtWiseData.length; index++) {
    //     labels.push(this.districtWiseData[index].District)
    //     areaData.push(this.districtWiseData[index].totalApp)
    //     const randomColor = "#" + ((1 << 24) * Math.random() | 0).toString(16);
    //     backgroundColors.push(randomColor)
    // }
    // this.pieChartData.labels = labels;
    // this.pieChartData.datasets[0].data = areaData;
    // this.pieChartData.datasets[0].backgroundColor = backgroundColors;
    // this.pieChartRef.reinit();


    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');

    let totalApproved = 0;
    let totalPending = 0;
    let totalRejectedApp = 0;

    if(this.isMIChecked){
      totalApproved = this.card1CountData?.CompletedApps;
      totalPending = this.card1CountData?.UnProcessedApps;
      totalRejectedApp = this.card1CountData?.rejectedApp;
    }else if(this.isPondChecked){
      totalApproved = this.pondCard1CountData?.CompletedApps;
      totalPending = this.pondCard1CountData?.UnProcessedApps;
      totalRejectedApp = this.pondCard1CountData?.rejectedApp
    }else if(this.isSolarChecked){
      totalApproved = this.solarCard1CountData?.TotalApprovedApp;
      totalPending = this.solarCard1CountData?.PendingApp;
      totalRejectedApp = this.solarCard1CountData?.rejectedApp;   
    }else if(this.isWaterCourseChecked){
      totalApproved = this.waterCourseCard1CountData?.TotalApprovedApp;
      totalPending = this.waterCourseCard1CountData?.PendingApp;
      totalRejectedApp = this.waterCourseCard1CountData?.rejectedApp;
    }

    this.pieChartData = {
      labels: [`Total Completed Application (${totalApproved})`, `Under Process Applications (${totalPending})`, `Rejected Applications (${totalRejectedApp})`],
      datasets: [
        {
          data: [totalApproved, totalPending, totalRejectedApp],
          backgroundColor: [
            documentStyle.getPropertyValue('--green-500'),
            documentStyle.getPropertyValue('--blue-500'),
            documentStyle.getPropertyValue('--pink-500'),
          ],
          hoverBackgroundColor: [
            documentStyle.getPropertyValue('--green-400'),
            documentStyle.getPropertyValue('--blue-400'),
            documentStyle.getPropertyValue('--pink-400'),
          ],
        },
      ],
    };

    this.options = {
      plugins: {
        legend: {
          labels: {
            usePointStyle: true,
            color: textColor,
          },
        },
      },
    };
  }

  // graph3
  loadLineGraphData() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const textColorSecondary = documentStyle.getPropertyValue(
      '--text-color-secondary'
    );
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    let month = this.lineGraphData.map((val) => val['MonthYear']);
    let recievedCount = this.lineGraphData.map((val) => val['TotalAppForLot']);
    let disbursedCount = this.lineGraphData.map(
      (val) => val['TotalAppDisbursed']
    );

    this.lineGraphData = {
      labels: month,
      datasets: [
        {
          label: 'Recieved Count',
          data: recievedCount,
          fill: false,
          borderColor: documentStyle.getPropertyValue('--blue-500'),
          tension: 0.4,
        },
        {
          label: 'Disbursed Dataset',
          data: disbursedCount,
          fill: false,
          borderColor: documentStyle.getPropertyValue('--green-500'),
          tension: 0.4,
        },
      ],
    };

    this.options = {
      maintainAspectRatio: false,
      aspectRatio: 0.6,
      plugins: {
        legend: {
          labels: {
            color: textColor,
          },
        },
      },
      scales: {
        x: {
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false,
          },
        },
        y: {
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false,
          },
        },
      },
    };

    // this.lineGraphData.labels = [...Horticulturelabels, ...Agriculturelabels, ...MICADAlabels];
    // this.lineGraphData.datasets[0].data = [...HorticulturemiAreaData, ...AgriculturemiAreaData, ...MICADAmiAreaData];
    // this.lineGraphData.datasets[1].data = [...HorticultureapplocationDataData, ...AgricultureapplocationDataData, ...MICADAapplocationDataData];
    // this.lineChartRef.reinit();
  }


  // not in use
  getChartData(selectedYear: any) {
    this.isChartLoading = true;

    let reqBody = {
      "financialYear": selectedYear,
      "district": '',
      "block": '',
      "constituency": '',
      "village": '',
      "cropid": 0,
      "caste": '',
      "isABY": ''
  }

    let sub = this.reportsService
      .getConsolidatedAggReport(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.isChartLoading = false;
            if (data?.length > 0) {
            this.summaryData = data[0];
            this.graphData();
          } else {
            this.summaryData = [];
          }
        },
        error: (err) => {
          this.isChartLoading = false;
          this.summaryData = [];
          this.graphData();
          // this.activityRecordService.activityRecord(
          //   this.userID,
          //   'MI Consolidated Chart Data',
          //   '',
          //   new Date(),
          //   err
          // );

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  // not in use
  loadAllMIGraphData() {
    let sub = this.reportsService
      .miCanalTubewellApplicationFromTBL()
      .pipe(first())
      .subscribe({
        next: (data) => {
          // console.log(data);

          if (data?.length > 0) {
            // console.log(data);
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Available',
            });
          }
        },
        error: (err) => {
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });

    this.subscriptions.push(sub);
  }


  // not in use
  loadAllPondGraphData() {
    let sub = this.reportsService
      .pondCanalTubewellApplicationFromTBL()
      .pipe(first())
      .subscribe({
        next: (data) => {
          // console.log(data);

          if (data?.length > 0) {
            // console.log(data);
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Available',
            });
          }
        },
        error: (err) => {
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });

    this.subscriptions.push(sub);
  }

  // not in use
  loadData(selectedYear: any) {
    this.loading = true;

    let sub = this.reportsService
      .getConsolidated_Report(selectedYear)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.activityRecordService.activityRecord(
          //   this.userID,
          //   'MI Consolidated Report',
          //   '',
          //   new Date(),
          //   'Success'
          // );
          // // this.loader.close();

          if (data?.length > 0) {
            this.consolidateData = data;
            // console.log(this.consolidateData);
            this.districtsArray = this.consolidateData.map(
              (item) => item['District']
            );
            this.distWiseTotalApp = this.consolidateData.map(
              (item) => item['totalApp']
            );
            // console.log(this.districtsArray);
            // this.loadPieChartData();

            this.appVerificationModel = data;
            this.tempConsolidateData = data;
            this.arrayIndex = 0;
            this.calculateGrandTotal();
            // this.applyNewGraph1Data();
            this.loading = false;
          } else {
            this.consolidateData = [];
            this.appVerificationModel = [];
            this.tempConsolidateData = [];
            this.calculateGrandTotal();
            // this.loader.close();
            this.loading = false;
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Available',
            });
          }
        },
        error: (err) => {
          // this.loader.close();
          this.consolidateData = [];
          this.appVerificationModel = [];
          this.tempConsolidateData = [];
          this.calculateGrandTotal();
          this.loading = false;
          // this.activityRecordService.activityRecord(
          //   this.userID,
          //   'MI Consolidated Report',
          //   '',
          //   new Date(),
          //   err
          // );

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'Financial Year': this.selectedYear == '' ? 'All' : this.selectedYear,
          District: d.District,
          // Block: d.Block,
          // Constituency: d.Constituency,
          '': '',
          'total App(application approval)': d.totalApp,
          'Total Area(application approval)': d.TotalArea,
          'Verified App(application approval)': d.VerifiedApp,
          'verified App Area(application approval)': d.verifiedAppArea,
          'Pending App(application approval)': d.PendingApp,
          'incomplete App Area(application approval)': d.incompleteAppArea,
          'reject App(application approval)': d.rejectApp,
          '  ': '',
          'total Estimated App(estimate)': d.totalEstimatedApp,
          'total Estimated Area(estimate)': d.totalEstimatedArea,
          'pending Estimate App(estimate)': d.pendingEstimateApp,
          '   ': ' ',
          'verified Estimate App (estimate Approval)': d.verifiedEstimateApp,
          'verified Estimate Area (estimate Approval)': d.verifiedEstimateArea,

          'verified Est Approved (estimate Approval)': d.verifiedEstApproved,
          'verified Est Approved Area (estimate Approval)':
            d.verifiedEstApprovedArea,
          'pending Est Approved (estimate Approval)': d.pendingEstApproved,
          'rejected Est Verified (estimate Approval)': d.rejectedEstVerified,
          '    ': ' ',
          'Challan Generated(challan)': d.ChallanGenerated,
          'Challan Deposited(challan)': d.ChallanDeposited,
          '     ': ' ',
          'BOQ Uploaded(BOQ)': d.BOQUploaded,
          'BOQ MI Area(BOQ)': d.BOQMIArea,
          'BOQ Pending(BOQ)': d.BOQPending,
          '      ': ' ',
          'PV Completed(PV)': d.PVCompleted,
          'PV MI Area(PV)': d.PV_MI_Area,
          'PV Pending with JE(PV)': d.PV_Pending_with_JE,
          'PV Pending with XEN(PV)': d.PV_Pending_with_XEN,
          '       ': ' ',
          'Pending Subsidy Calculation(SUBSIDY CAL)':
            d.Pending_Subsidy_Calculation,
          'Applications with DMI for Subsidy_Approval(SUBSIDY CAL)':
            d.ApplicationswithDMIforSubsidy_Approval,
          'Applications Approved at Administartion(SUBSIDY CAL)':
            d.Applications_Approved_at_Administartion,
          'Subsisdy Approved MI Area(SUBSIDY CAL)': d.Subsisdy_Approved_MI_Area,
          'Assistance Amount(SUBSIDY CAL)': d.AssistanceAmount,
          '        ': ' ',
          'Pending Application For Payment By CAO(SUBSIDY )':
            d.Pending_Application_For_Payment_By_CAO,
          'Payment Done Application By CAO(SUBSIDY )':
            d.Payment_Done_Application_By_CAO,
          'Payment done MI Area(SUBSIDY )': d.Payment_done_MI_Area,
        };
      });

      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      {
        field: this.selectedYear == '' ? 'All' : this.selectedYear,
        header: 'Finacial Year',
      },
      { field: 'District', header: 'District' },
      // { field: 'Block', header: 'Block' },
      // { field: 'Constituency', header: 'Constituency' },
      { field: 'totalApp', header: 'Total App' },
      { field: 'TotalArea', header: 'Total Area' },
      { field: 'VerifiedApp', header: 'Verf App' },
      { field: 'verifiedAppArea', header: 'verf App Area' },
      { field: 'PendingApp', header: 'Pending App' },
      { field: 'incompleteAppArea', header: 'Incomplete App Area' },
      { field: 'rejectApp', header: 'Reject App' },
      { field: 'totalEstimatedApp', header: 'Total Est App' },
      { field: 'totalEstimatedArea', header: 'Vendor Name' },
      { field: 'verifiedEstimateApp', header: 'Verf EstApp' },
      { field: 'verifiedEstimateArea', header: 'Verf Est Area' },
      { field: 'pendingEstimateApp', header: 'Pending Est App' },
      { field: 'verifiedEstApproved', header: 'Verf Est Approved' },
      { field: 'verifiedEstApprovedArea', header: 'Verf Est Approved Area' },
      { field: 'pendingEstApproved', header: 'Pending Est Approved' },
      { field: 'rejectedEstVerified', header: 'Rejected Est verf' },
      { field: 'ChallanGenerated', header: 'Challan Gen' },
      { field: 'ChallanDeposited', header: 'Challan Dep' },
      { field: 'BOQUploaded', header: 'BOQ Uploaded' },
      { field: 'BOQMIArea', header: 'BOQ MI Area' },
      { field: 'BOQPending', header: 'BOQ Pending' },
      { field: 'PVCompleted', header: 'PV Completed' },
      { field: 'PV_MI_Area', header: 'PV MI Area' },
      { field: 'PV_Pending_with_JE', header: 'PV Pending with JE' },
      { field: 'PV_Pending_with_XEN', header: 'PV Pending with XEN' },
      { field: 'Pending_Subsidy_Calculation', header: 'Pending Subsidy Cal' },
      {
        field: 'ApplicationswithDMIforSubsidy_Approval',
        header: 'App with DMI for Subsidy_Approval',
      },
      {
        field: 'Applications_Approved_at_Administartion',
        header: 'App Approved at Admin',
      },
      {
        field: 'Subsisdy_Approved_MI_Area',
        header: 'Subsisdy Approved MI Area',
      },
      { field: 'AssistanceAmount', header: 'Assistance Amt' },
      {
        field: 'Pending_Application_For_Payment_By_CAO',
        header: 'Pending App For Payment By CAO',
      },
      {
        field: 'Payment_Done_Application_By_CAO',
        header: 'Payment Done App By CAO',
      },
      { field: 'Payment_done_MI_Area', header: 'Payment done MI Area' },
    ];

    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));

    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then((x) => {
        const doc = new jsPDF.default({ orientation: 'landscape' });
        doc.autoTable(this.exportColumns, modelData, {
          styles: { fontSize: 2 },
        });
        doc.save(`${filename}.pdf`);
      });
    });
  }
  tableDataFunction(event: any) {
    this.tempConsolidateData = event.filteredValue;
    this.arrayIndex = 0;
    this.calculateTotalApp();
  }
  onPage(event: any) {
    this.arrayIndex = event.first;
    this.calculateTotalApp();
  }
  calculateTotalApp() {
    this.totalApp = 0;
    this.totalArea = 0;
    this.incompleteAppArea = 0;
    this.verifiedApp = 0;
    this.verifiedAppArea = 0;
    this.pendingApp = 0;
    this.incompleteApp = 0;
    this.incompleteAppArea = 0;
    this.rejectApp = 0;
    this.totalEstimatedApp = 0;
    this.totalEstimatedArea = 0;
    this.verifiedEstimateApp = 0;
    this.verifiedEstimateArea = 0;
    this.pendingEstimateApp = 0;
    this.verifiedEstApproved = 0;
    this.verifiedEstApprovedArea = 0;
    this.pendingEstApproved = 0;
    this.rejectedEstVerified = 0;
    this.challanGenerated = 0;
    this.challanDeposited = 0;
    this.BOQUploaded = 0;
    this.BOQMIArea = 0;
    this.BOQPending = 0;
    this.PVCompleted = 0;
    this.PV_MI_Area = 0;
    this.PV_Pending_with_JE = 0;
    this.PV_Pending_with_XEN = 0;
    this.pending_Subsidy_Calculation = 0;
    this.applicationswithDMIforSubsidy_Approval = 0;
    this.applications_Approved_at_Administartion = 0;
    this.subsisdy_Approved_MI_Area = 0;
    this.assistanceAmount = 0;
    this.pending_Application_For_Payment_By_CAO = 0;
    this.payment_Done_Application_By_CAO = 0;
    this.payment_done_MI_Area = 0;
    for (
      let i = this.arrayIndex;
      this.tempConsolidateData.length > 10
        ? i < this.arrayIndex + 10
        : i < this.tempConsolidateData.length;
      i++
    ) {
      this.totalApp += this.tempConsolidateData[i].totalApp;
      this.totalArea += this.tempConsolidateData[i].TotalArea;
      this.verifiedApp += this.tempConsolidateData[i].VerifiedApp;
      this.verifiedAppArea += this.tempConsolidateData[i].verifiedAppArea;
      this.pendingApp += this.tempConsolidateData[i].PendingApp;
      this.incompleteApp += this.tempConsolidateData[i].IncompleteApp;
      this.incompleteAppArea += this.tempConsolidateData[i].incompleteAppArea;
      this.rejectApp += this.tempConsolidateData[i].rejectApp;
      this.totalEstimatedApp += this.tempConsolidateData[i].totalEstimatedApp;
      this.totalEstimatedArea += this.tempConsolidateData[i].totalEstimatedArea;
      this.verifiedEstimateApp +=
        this.tempConsolidateData[i].verifiedEstimateApp;
      this.verifiedEstimateArea +=
        this.tempConsolidateData[i].verifiedEstimateArea;
      this.pendingEstimateApp += this.tempConsolidateData[i].pendingEstimateApp;
      this.verifiedEstApproved +=
        this.tempConsolidateData[i].verifiedEstApproved;
      this.verifiedEstApprovedArea +=
        this.tempConsolidateData[i].verifiedEstApprovedArea;
      this.pendingEstApproved += this.tempConsolidateData[i].pendingEstApproved;
      this.rejectedEstVerified +=
        this.tempConsolidateData[i].rejectedEstVerified;
      this.challanGenerated += this.tempConsolidateData[i].ChallanGenerated;
      this.challanDeposited += this.tempConsolidateData[i].ChallanDeposited;
      this.BOQUploaded += this.tempConsolidateData[i].BOQUploaded;
      this.BOQMIArea += this.tempConsolidateData[i].BOQMIArea;
      this.BOQPending += this.tempConsolidateData[i].BOQPending;
      this.PVCompleted += this.tempConsolidateData[i].PVCompleted;
      this.PV_MI_Area += this.tempConsolidateData[i].PV_MI_Area;
      this.PV_Pending_with_JE += this.tempConsolidateData[i].PV_Pending_with_JE;
      this.PV_Pending_with_XEN +=
        this.tempConsolidateData[i].PV_Pending_with_XEN;
      this.pending_Subsidy_Calculation +=
        this.tempConsolidateData[i].Pending_Subsidy_Calculation;
      this.applicationswithDMIforSubsidy_Approval +=
        this.tempConsolidateData[i].ApplicationswithDMIforSubsidy_Approval;
      this.applications_Approved_at_Administartion +=
        this.tempConsolidateData[i].Applications_Approved_at_Administartion;
      this.subsisdy_Approved_MI_Area +=
        this.tempConsolidateData[i].Subsisdy_Approved_MI_Area;
      this.assistanceAmount += this.tempConsolidateData[i].AssistanceAmount;
      this.pending_Application_For_Payment_By_CAO +=
        this.tempConsolidateData[i].Pending_Application_For_Payment_By_CAO;
      this.payment_Done_Application_By_CAO +=
        this.tempConsolidateData[i].Payment_Done_Application_By_CAO;
      this.payment_done_MI_Area +=
        this.tempConsolidateData[i].Payment_done_MI_Area;
    }
    // this.verfAppArea= this.verfAppArea.toFixed(4);
  }
  calculateGrandTotal() {
    this.grandTotalApp = 0;
    this.grandTotalArea = 0;
    this.grandVerifiedApp = 0;
    this.grandVerifiedAppArea = 0;
    this.grandPendingApp = 0;
    this.grandIncompleteApp = 0;
    this.grandIncompleteAppArea = 0;
    this.grandRejectApp = 0;
    this.grandTotalEstimatedApp = 0;
    this.grandTotalEstimatedArea = 0;
    this.grandVerifiedEstimateApp = 0;
    this.grandVerifiedEstimateArea = 0;
    this.grandPendingEstimateApp = 0;
    this.grandVerifiedEstApproved = 0;
    this.grandVerifiedEstApprovedArea = 0;
    this.grandPendingEstApproved = 0;
    this.grandRejectedEstVerified = 0;
    this.grandChallanGenerated = 0;
    this.grandChallanDeposited = 0;
    this.grandBOQUploaded = 0;
    this.grandBOQMIArea = 0;
    this.grandBOQPending = 0;
    this.grandPVCompleted = 0;
    this.grandPV_MI_Area = 0;
    this.grandPV_Pending_with_JE = 0;
    this.grandPV_Pending_with_XEN = 0;
    this.grandPending_Subsidy_Calculation = 0;
    this.grandApplicationswithDMIforSubsidy_Approval = 0;
    this.grandApplications_Approved_at_Administartion = 0;
    this.grandSubsisdy_Approved_MI_Area = 0;
    this.grandAssistanceAmount = 0;
    this.grandPending_Application_For_Payment_By_CAO = 0;
    this.grandPayment_Done_Application_By_CAO = 0;
    this.grandPayment_done_MI_Area = 0;

    for (let vendorData of this.tempConsolidateData) {
      this.grandTotalApp += vendorData.totalApp;
      this.grandTotalArea += vendorData.TotalArea;
      this.grandVerifiedApp += vendorData.VerifiedApp;
      this.grandVerifiedAppArea += vendorData.verifiedAppArea;
      this.grandPendingApp += vendorData.PendingApp;
      this.grandIncompleteApp += vendorData.IncompleteApp;
      this.grandIncompleteAppArea += vendorData.incompleteAppArea;
      this.grandRejectApp += vendorData.rejectApp;
      this.grandTotalEstimatedApp += vendorData.totalEstimatedApp;
      this.grandTotalEstimatedArea += vendorData.totalEstimatedArea;
      this.grandVerifiedEstimateApp += vendorData.verifiedEstimateApp;
      this.grandVerifiedEstimateArea += vendorData.verifiedEstimateArea;
      this.grandPendingEstimateApp += vendorData.pendingEstimateApp;
      this.grandVerifiedEstApproved += vendorData.verifiedEstApproved;
      this.grandVerifiedEstApprovedArea += vendorData.verifiedEstApprovedArea;
      this.grandPendingEstApproved += vendorData.pendingEstApproved;
      this.grandRejectedEstVerified += vendorData.rejectedEstVerified;
      this.grandChallanGenerated += vendorData.ChallanGenerated;
      this.grandChallanDeposited += vendorData.ChallanDeposited;
      this.grandBOQUploaded += vendorData.BOQUploaded;
      this.grandBOQMIArea += vendorData.BOQMIArea;
      this.grandBOQPending += vendorData.BOQPending;
      this.grandPVCompleted += vendorData.PVCompleted;
      this.grandPV_MI_Area += vendorData.PV_MI_Area;
      this.grandPV_Pending_with_JE += vendorData.PV_Pending_with_JE;
      this.grandPV_Pending_with_XEN += vendorData.PV_Pending_with_XEN;
      this.grandPending_Subsidy_Calculation +=
        vendorData.Pending_Subsidy_Calculation;
      this.grandApplicationswithDMIforSubsidy_Approval +=
        vendorData.ApplicationswithDMIforSubsidy_Approval;
      this.grandApplications_Approved_at_Administartion +=
        vendorData.Applications_Approved_at_Administartion;
      this.grandSubsisdy_Approved_MI_Area +=
        vendorData.Subsisdy_Approved_MI_Area;
      this.grandAssistanceAmount += vendorData.AssistanceAmount;
      this.grandPending_Application_For_Payment_By_CAO +=
        vendorData.Pending_Application_For_Payment_By_CAO;
      this.grandPayment_Done_Application_By_CAO +=
        vendorData.Payment_Done_Application_By_CAO;
      this.grandPayment_done_MI_Area += vendorData.Payment_done_MI_Area;
    }
  }

  getTotalRecord() {
    this.isFinYearChanged = true;
    this.selectedYear = '';
    this.loadData(this.selectedYear);
    this.getChartData(this.selectedYear);
  }

  showPendingDetailUserDialog(value, actionType, ...args) {
    // this.value = value;
    this.drilldownDetails = {
      ActionType: actionType,
      District: value?.District,
      FinYear: this.financialYears,
      RequestType: 'MI',
      ReqParam: args[0] ? args[0] : '',
    };

    this.displayPendingDetailUser = true;
    // console.log(this.drilldownDetails, 'this.drilldownDetails');
  }

  showPendingDetailUserWiseDialog(value, actionType) {
    // this.value = value;
    this.drilldownDetails = {
      ActionType: actionType,
      District: value?.District,
      FinYear: this.financialYears,
    };

    this.displayPendingDetailUserWise = true;
    // console.log(this.drilldownDetails, 'drilldownDetails userWise');
  }

  // not in use
  graphData() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    this.data = {
      labels: [
        'Farmer Applications',
        'Pre Survey',
        'Vendor Estimates',
        'Estimate Verification',
        'Total Farmer Challan',
        'Total Bills of Quantity',
        'Total Physical Verification',
        'Total Subsidy Calculated',
        'Total Subsidy Disbursed',
      ],
      datasets: [
        {
          label: 'Total',
          backgroundColor: documentStyle.getPropertyValue('--blue-500'),
          borderColor: documentStyle.getPropertyValue('--blue-500'),
          data: [
            this.summaryData?.totalApp ? this.summaryData?.totalApp : 0,
            this.summaryData?.total_Preestimate
              ? this.summaryData?.total_Preestimate
              : 0,
            this.summaryData?.totalEstimatedApp
              ? this.summaryData?.totalEstimatedApp
              : 0,
            this.summaryData?.TotalEstApproved
              ? this.summaryData?.TotalEstApproved
              : 0,
            this.summaryData?.TotalChallan_tobe_Generated
              ? this.summaryData?.TotalChallan_tobe_Generated
              : 0,
            this.summaryData?.TotalBOQ_tobe_Uploaded
              ? this.summaryData?.TotalBOQ_tobe_Uploaded
              : 0,
            this.summaryData?.totalPV_tobe_done
              ? this.summaryData?.totalPV_tobe_done
              : 0,
            this.summaryData?.TotalApplicationswithDMIforSubsidy_Approval
              ? this.summaryData?.TotalApplicationswithDMIforSubsidy_Approval
              : 0,
            this.summaryData?.total_Application_For_Payment_By_CAO
              ? this.summaryData?.total_Application_For_Payment_By_CAO
              : 0,
          ],
        },
        {
          label: 'Completed',
          backgroundColor: documentStyle.getPropertyValue('--green-500'),
          borderColor: documentStyle.getPropertyValue('--green-500'),
          data: [
            this.summaryData?.VerifiedApp ? this.summaryData?.VerifiedApp : 0,
            this.summaryData?.verified_Preestimate
              ? this.summaryData?.verified_Preestimate
              : 0,
            this.summaryData?.verifiedEstimateApp
              ? this.summaryData?.verifiedEstimateApp
              : 0,
            this.summaryData?.verifiedEstApproved
              ? this.summaryData?.verifiedEstApproved
              : 0,
            this.summaryData?.ChallanGenerated
              ? this.summaryData?.ChallanGenerated
              : 0,
            this.summaryData?.BOQUploaded ? this.summaryData?.BOQUploaded : 0,
            this.summaryData?.PVCompleted ? this.summaryData?.PVCompleted : 0,
            this.summaryData?.Applications_Approved_at_Administartion
              ? this.summaryData?.Applications_Approved_at_Administartion
              : 0,
            this.summaryData?.Payment_Done_Application_By_CAO
              ? this.summaryData?.Payment_Done_Application_By_CAO
              : 0,
          ],
        },
        {
          label: 'Pending',
          backgroundColor: documentStyle.getPropertyValue('--pink-500'),
          borderColor: documentStyle.getPropertyValue('--pink-500'),
          data: [
            this.summaryData?.IncompleteApp
              ? this.summaryData?.IncompleteApp
              : 0,
            this.summaryData?.pending_Preestimate
              ? this.summaryData?.pending_Preestimate
              : 0,
            this.summaryData?.pendingEstimateApp
              ? this.summaryData?.pendingEstimateApp
              : 0,
            this.summaryData?.pendingEstApproved
              ? this.summaryData?.pendingEstApproved
              : 0,
            this.summaryData?.PendingChallanGenerated
              ? this.summaryData?.PendingChallanGenerated
              : 0,
            this.summaryData?.BOQPending ? this.summaryData?.BOQPending : 0,
            this.summaryData?.PV_Pending ? this.summaryData?.PV_Pending : 0,
            this.summaryData?.Pending_Subsidy_Calculation
              ? this.summaryData?.Pending_Subsidy_Calculation
              : 0,
            this.summaryData?.Pending_Application_For_Payment_By_CAO
              ? this.summaryData?.Pending_Application_For_Payment_By_CAO
              : 0,
          ],
        },
      ],
    };

    this.options = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        legend: {
          labels: {
            color: textColor,
          },
        },
      },
      scales: {
        x: {
          ticks: {
            color: textColorSecondary,
            font: {
              weight: 500,
            },
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false,
          },
        },
        y: {
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false,
          },
        },
      },
    };
  }

  // not in use
  getCorpType() {
    this.flService
      .GetCorpType()
      .pipe(first())
      .subscribe({
        next: (files) => {
          this.cropTypeList = files;
          // console.log(this.cropTypeList, 'this.cropTypeList');
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Corp Type Details not loaded.',
          });
        },
      });
  }

  // not in use
  getCropTypeName(event) {
    const data = this.cropTypeList.find((element) => element.data == event);
    if (data) {
      this.cropBasedNames = data.children;
    } else {
      this.cropBasedNames = [];
    }
  }

  // not in use
  getComponentMaster() {
    this.loader.start();
    this.vendorService
      .getComponentMaster()
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.program = res;
          this.loader.close();
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  // not in use
  getCaste() {
    setTimeout(() => {
      this.caste = [
        {
          name: 'Gen',
          id: 1,
        },
        {
          name: 'OBC',
          id: 2,
        },
        {
          name: 'SC/ST',
          id: 3,
        },
      ];
    }, 1000);
  }

  // not in use
  getAppType() {
    setTimeout(() => {
      this.appType = [
        {
          name: 'Normal',
          id: 1,
        },
        {
          name: 'ABY',
          id: 2,
        },
      ];
    }, 1000);
  }

  onClickMITotalAppRep(){
    const finYear = this.selectedFinYear.year;

    if(this.userID == 'admin'){
      this.router.navigate(['admin', 'report', 'mi-total-app-report']);
    }
    else if(this.userID == 'cao'){
      this.router.navigate(['cao', 'report', 'mi-total-app-report']);
    }
    else{
      this.router.navigate(['department', 'report', 'mi-total-app-report']);
    }
    
  }

  onClickPondTotalAppRep(){
    const finYear = this.selectedFinYear.year;

    if(this.userID == 'admin'){
      this.router.navigate(['admin', 'report', 'pond-total-app-report']);
    }
    else if(this.userID == 'cao'){
      this.router.navigate(['cao', 'report', 'pond-total-app-report']);
    }
    else{
      this.router.navigate(['ew-department', 'report', 'pond-total-app-report']);
    }
  }
}
